import React from 'react';
import { useContextSelector } from 'use-context-selector';
import { CatalogContext } from '@context/catalog.context';
import { Trans } from 'next-i18next';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import styles from './suggested-search-query.module.scss';

const SuggestedSearchQuery = () => {
  const keywordSuggestion = useContextSelector(CatalogContext, (v) => v.keywordSuggestion);
  const searchQuery = useContextSelector(CatalogContext, (v) => v.searchQuery);
  const { sendAnalyticEvent } = useAnalyticEvents('catalog');

  if (!keywordSuggestion.hasSuggestion) {
    return null;
  }

  if (keywordSuggestion.isAutoCorrected) {
    return (
      <div className={styles.suggestedSearchQuery}>
        <Trans
          i18nKey="CATALOG.AUTO_CORRECTION.TITLE"
          components={{
            1: (
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              <a
                className={styles.suggestedSearchQuery__suggestion}
                href={`/search?q=${keywordSuggestion.suggestedSearchQuery}`}
              />
            ),
          }}
          values={{
            searchQuery: keywordSuggestion.suggestedSearchQuery,
          }}
        />
      </div>
    );
  }

  return (
    <div className={styles.suggestedSearchQuery}>
      <Trans
        i18nKey="CATALOG.DID_YOU_MEAN.TITLE"
        components={{
          1: <span className={styles.suggestedSearchQuery__originalQuery} />,
          2: (
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            <a
              className={styles.suggestedSearchQuery__suggestion}
              href={`/search?q=${keywordSuggestion.suggestedSearchQuery}&originalQuery=${searchQuery}`}
              onClick={() => {
                sendAnalyticEvent('did_you_mean_click', {
                  label: keywordSuggestion.suggestedSearchQuery,
                });
              }}
            />
          ),
        }}
        values={{
          searchQuery: searchQuery,
          suggestedSearchQuery: keywordSuggestion.suggestedSearchQuery,
        }}
      />
    </div>
  );
};

export default SuggestedSearchQuery;
